import React from "react"
import ReactDOM from "react-dom"
import ShowcaseVideoComponent from "./showcase-video-component"

export default class ShowcaseVideoModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    self.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<ShowcaseVideoComponent {...this.modelJson} />, self.elem)
  }
}
